var _g, _path, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiagnoseVehicle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 140,
    height: 54,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#diagnose-vehicle_svg__filter0_ii_18182_114638)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.978 51.587c-6.679-.192-12.453-4.63-14.503-11.001l-.145-.45a43.708 43.708 0 01.577-28.49 15.378 15.378 0 0114.415-10.07c11.326-.023 30.592-.042 52.714.016 18.376.048 36.838.64 48.9 1.118 7.989.317 14.615 6.262 15.899 14.16l.392 2.41c.93 5.723.811 11.561-.352 17.23l-.192.935c-1.6 7.799-8.421 13.399-16.388 13.488-10.895.122-27.707.358-48.195.808-22.71.498-41.804.17-53.122-.154z",
    fill: "url(#diagnose-vehicle_svg__paint0_linear_18182_114638)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.59 46.345c-5.029 1.053-10.219-1.99-11.44-6.997l-.1-.408a48.386 48.386 0 01.458-24.707c1.356-4.766 6.456-7.464 11.29-6.312 7.66 1.824 19.663 3.995 33.341 3.97 11.364-.021 22.808-1.63 30.84-3.08 5.832-1.054 11.586 2.95 12.305 8.848l.119.977a66.31 66.31 0 01-.342 18.473c-.884 5.532-6.683 9.002-12.173 7.829-7.267-1.553-17.93-3.073-30.749-2.639a199.153 199.153 0 00-33.55 4.046z",
    fill: "#A7A5A5"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#diagnose-vehicle_svg__filter1_di_18182_114638)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.42 48.469c-7.692-.429-14.527-5.14-17.873-12.099-2.949-6.13-3.009-13.303-.117-19.425A20.881 20.881 0 0125.03 4.964c3.814-.055 8.256-.116 13.038-.176.174-.002.25.231.112.338-.138.109-.038.324.137.304a10.19 10.19 0 013.23.154c8.493 1.783 22.281 4.007 38.09 3.966 12.534-.032 25.157-1.822 34.114-3.462a12.103 12.103 0 014.789.087c.051.011.083-.052.044-.085a.05.05 0 01.035-.088c2.862.18 5.318.346 7.212.48a6.491 6.491 0 015.652 4.321l.377 1.058c3.673 10.321 3.529 21.595-.407 31.771a6.01 6.01 0 01-5.256 3.85c-2.102.125-4.988.292-8.47.48-.204.012-.29-.277-.12-.39.168-.112.06-.365-.14-.343-1.256.14-2.546.086-3.821-.187-8.111-1.735-19.896-3.401-34.025-2.904-16.064.565-29.686 2.924-38.222 4.783-.454.1-.91.165-1.363.2-.027.003-.032.04-.007.048.027.01.019.051-.01.05-5.805-.233-11.16-.503-15.6-.75zm18.02-3.08c-4.781.986-9.692-1.896-10.884-6.645l-.1-.4a46.444 46.444 0 01.459-24.33c1.32-4.518 6.156-7.073 10.752-5.993 7.597 1.787 19.722 3.968 33.576 3.947 11.525-.018 23.132-1.633 31.14-3.056 5.567-.99 11.042 2.828 11.747 8.45l.119.948a63.761 63.761 0 01-.345 18.264c-.866 5.277-6.383 8.587-11.625 7.474-7.233-1.536-18.016-3.08-31.031-2.655-14.168.464-26.2 2.428-33.808 3.997z",
    fill: "url(#diagnose-vehicle_svg__paint1_linear_18182_114638)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#diagnose-vehicle_svg__filter2_di_18182_114638)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.206 48.344a.814.814 0 01-1.006-.59l-5.133-21.046a.796.796 0 01.007-.406l5.7-20.031a.803.803 0 011.02-.543c3.776 1.208 20.641 6.201 41.345 6.163 18.264-.034 36.736-4.167 40.913-5.16a.807.807 0 01.985.69l2.481 20.373a.783.783 0 01-.004.222l-3.01 18.835a.811.811 0 01-1.062.639c-3.784-1.278-19.094-5.91-40.303-5.19-21.534.73-38.162 5.002-41.933 6.044z",
    fill: "url(#diagnose-vehicle_svg__paint2_linear_18182_114638)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#diagnose-vehicle_svg__filter3_d_18182_114638)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#diagnose-vehicle_svg__filter4_d_18182_114638)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.906 6.024c-3.604 1.678-4.582 4.14-4.637 5.826-.018.563.623.774 1.07.43 3.533-2.713 9.088-5.131 12.988-6.572.735-.272.654-1.238-.128-1.28-2.582-.141-6.117.116-9.293 1.596z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.391 7.07c-2.277 1.06-3.296 2.408-3.714 3.542 2.856-1.961 6.56-3.711 9.744-5.011-1.936.137-4.068.555-6.03 1.468z",
    stroke: "#fff",
    strokeWidth: 2.307,
    strokeLinecap: "round"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#diagnose-vehicle_svg__filter5_d_18182_114638)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.106 48.17c-3.827-1.68-4.882-4.252-4.957-6.007-.023-.563.614-.786 1.068-.451 3.769 2.777 9.704 5.195 13.816 6.603.741.254.684 1.226-.097 1.29-2.695.22-6.442.052-9.83-1.435z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.57 47.113c-2.5-1.096-3.59-2.553-4.021-3.764 3.11 2.06 7.194 3.864 10.642 5.168-2.1-.074-4.452-.451-6.622-1.404z",
    stroke: "#fff",
    strokeWidth: 2.307,
    strokeLinecap: "round"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#diagnose-vehicle_svg__filter6_di_18182_114638)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.696 42.14c.981 3.722 4.159 6.452 7.992 6.726 1.076.077 2.277.157 3.594.237-4.04-.456-7.623-3.308-8.596-7.437l-.514-2.18a51.508 51.508 0 01.672-26.214l.264-.906c1.429-4.906 6.604-7.74 11.617-6.678 8.377 1.775 21.854 3.961 37.288 3.921 12.192-.032 24.47-1.78 33.267-3.403.178-.033.356-.062.533-.087a10.856 10.856 0 00-2.38-.445c-8.643-.64-22.438-1.463-36.124-1.46-16.7.004-31.08.44-38.956.738-3.863.146-7.173 2.724-8.3 6.415l-.273.891a51.515 51.515 0 00-.53 28.187l.446 1.696zm87.413 5.146a11.9 11.9 0 01-1.918-.25c-7.975-1.712-19.46-3.33-33.194-2.84-15.68.56-28.995 2.884-37.412 4.736a10.07 10.07 0 01-2.213.235c8.126.464 20.204.867 34.43.44 15.826-.474 28.801-1.065 36.671-1.463a10.305 10.305 0 003.636-.858z",
    fill: "url(#diagnose-vehicle_svg__paint3_linear_18182_114638)"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#diagnose-vehicle_svg__filter7_ii_18182_114638)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.616 49.367c-8.004-.457-15.091-5.423-18.474-12.715-2.853-6.148-2.91-13.268-.115-19.4a21.456 21.456 0 0119.228-12.57c3.759-.056 8.094-.118 12.739-.177.103-.001.145.136.062.196-.085.06-.032.191.072.182a10.246 10.246 0 013.066.195c8.428 1.832 21.948 4.079 37.425 4.037 12.005-.032 24.091-1.765 32.894-3.411a12.706 12.706 0 011.684-.2c.994.06 1.954.12 2.877.18.304.053.605.118.903.193.038.01.064-.04.033-.065-.028-.023-.009-.069.027-.066 2.759.179 5.144.345 7.015.481 2.727.198 5.056 2.02 5.946 4.612l.367 1.068c3.613 10.523 3.473 21.947-.398 32.322a6.304 6.304 0 01-5.527 4.104c-1.856.114-4.287.26-7.172.423-.305.018-.454-.395-.221-.593.239-.203.025-.572-.281-.507-1.725.37-3.544.393-5.33.008-7.993-1.723-19.332-3.31-32.832-2.815-15.723.578-29.083 2.967-37.55 4.878-.865.195-1.736.272-2.593.24-.026-.001-.035.033-.013.045.022.012.013.047-.013.046-5.093-.218-9.81-.463-13.819-.691zm17.755-3.318c-5.019 1.054-10.209-1.987-11.42-6.989l-.097-.404a48.154 48.154 0 01.444-24.397c1.343-4.76 6.438-7.454 11.264-6.299C53.11 9.767 64.87 11.9 78.26 11.88c11.12-.018 22.318-1.592 30.218-3.024 5.814-1.054 11.558 2.942 12.269 8.822l.117.97a65.913 65.913 0 01-.331 18.22c-.873 5.515-6.66 8.973-12.132 7.8-7.152-1.533-17.597-3.023-30.136-2.597a194.532 194.532 0 00-32.894 3.979z",
    fill: "url(#diagnose-vehicle_svg__paint4_linear_18182_114638)"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#diagnose-vehicle_svg__filter8_ii_18182_114638)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.124 43.748a46.54 46.54 0 01-.184-32.737l.136-.368s6.965.92 21.768.92c14.711-.353 21.319-1.629 21.319-1.629l.276 1.262a72.092 72.092 0 01-.367 32.352s-11.317-1.335-21.241-1.26c-8.528.066-21.707 1.46-21.707 1.46z",
    fill: "url(#diagnose-vehicle_svg__paint5_linear_18182_114638)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "diagnose-vehicle_svg__filter0_ii_18182_114638",
    x: 3.223,
    y: -1.522,
    width: 137.93,
    height: 53.519,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2.307,
    dy: -3.076
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 9.227
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.07 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_18182_114638"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.384
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.769
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_innerShadow_18182_114638",
    result: "effect2_innerShadow_18182_114638"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "diagnose-vehicle_svg__filter1_di_18182_114638",
    x: 2.76,
    y: 4.788,
    width: 132.152,
    height: 45.969,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.398
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.199
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.925374 0 0 0 0 0.925374 0 0 0 0 0.925374 0 0 0 0.37 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_18182_114638"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_18182_114638",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1.538,
    dy: 1.922
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.769
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect2_innerShadow_18182_114638"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "diagnose-vehicle_svg__filter2_di_18182_114638",
    x: 28.506,
    y: 5.689,
    width: 94.415,
    height: 44.223,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.398
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.199
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.925374 0 0 0 0 0.925374 0 0 0 0 0.925374 0 0 0 0.37 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_18182_114638"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_18182_114638",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1.538,
    dy: 1.922
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.769
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect2_innerShadow_18182_114638"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "diagnose-vehicle_svg__filter3_d_18182_114638",
    x: 11.5,
    y: 2.856,
    width: 16.104,
    height: 9.591,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.769
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.384
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_18182_114638"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_18182_114638",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "diagnose-vehicle_svg__filter4_d_18182_114638",
    x: 11.884,
    y: 4.394,
    width: 15.335,
    height: 8.822,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.384
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.192
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_18182_114638"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_18182_114638",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "diagnose-vehicle_svg__filter5_d_18182_114638",
    x: 11.38,
    y: 40.017,
    width: 16.946,
    height: 9.667,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.769
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.384
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_18182_114638"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_18182_114638",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "diagnose-vehicle_svg__filter6_di_18182_114638",
    x: 24.002,
    y: 4.214,
    width: 91.505,
    height: 47.112,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.398
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.199
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.925374 0 0 0 0 0.925374 0 0 0 0 0.925374 0 0 0 0.37 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_18182_114638"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_18182_114638",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1.538,
    dy: 1.922
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.769
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect2_innerShadow_18182_114638"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "diagnose-vehicle_svg__filter7_ii_18182_114638",
    x: 6.966,
    y: 1.429,
    width: 131.317,
    height: 48.629,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2.307,
    dy: -3.076
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 9.227
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.07 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_18182_114638"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.384
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.769
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.09 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_innerShadow_18182_114638",
    result: "effect2_innerShadow_18182_114638"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "diagnose-vehicle_svg__filter8_ii_18182_114638",
    x: 56.058,
    y: 6.858,
    width: 50.347,
    height: 36.89,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2.307,
    dy: -3.076
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 9.227
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.07 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_18182_114638"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.384
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.769
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_innerShadow_18182_114638",
    result: "effect2_innerShadow_18182_114638"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "diagnose-vehicle_svg__paint0_linear_18182_114638",
    x1: 133.066,
    y1: 31.51,
    x2: 124.651,
    y2: 67.23,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "diagnose-vehicle_svg__paint1_linear_18182_114638",
    x1: 383.286,
    y1: 6.473,
    x2: 346.41,
    y2: 120.988,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8EAE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.498,
    stopColor: "#707072"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F3032"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "diagnose-vehicle_svg__paint2_linear_18182_114638",
    x1: 299.536,
    y1: 11.919,
    x2: 251.24,
    y2: 114.581,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8EAE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.498,
    stopColor: "#707072"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F3032"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "diagnose-vehicle_svg__paint3_linear_18182_114638",
    x1: 286.226,
    y1: 5.951,
    x2: 235.655,
    y2: 111.288,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8EAE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.498,
    stopColor: "#707072"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F3032"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "diagnose-vehicle_svg__paint4_linear_18182_114638",
    x1: 129.926,
    y1: 30.176,
    x2: 123.331,
    y2: 62.228,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "diagnose-vehicle_svg__paint5_linear_18182_114638",
    x1: 114.633,
    y1: 14.968,
    x2: 101.892,
    y2: 51.118,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D2D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.351,
    stopColor: "#CACACA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6F6F6"
  })))));
}
export default __webpack_public_path__ + "static/media/diagnose-vehicle.c84bcb0a.svg";
export { SvgDiagnoseVehicle as ReactComponent };